import '../../scss/widgets/widget-coin-rating.scss';
import widgetsDataService from '../services/widgetsDataService.js'

const coinRating = {
    async updateDynamicsData() {
        let widgets = $('.widget-coin-rating-wrapper');

        for (let i = 0; i < widgets.length; i++) {
            let data = $(widgets[i]).data();
            let coinIdsArray = data.coinIds.replace(/\s+/g, '').split(',');
            let widgetData = await widgetsDataService.fetchWidgetDataAsync('getСoinRatingData', data.coinIds, data.currency);
            coinIdsArray.forEach(coinId => {
                widgetsDataService.updateDataOnPage(`.widget-coin-rating[data-coin-id="${coinId}"]`, widgetData[coinId]);
            })
        }
    }
}

export default coinRating;